const NO_CONTENT = 204;
const NO_FOUND = 404;
const CONFLIT = 409;
const BAD_REQUEST = 400;

const erreursParticulieres = new Set([NO_FOUND, CONFLIT, BAD_REQUEST]);

export const jsonHeaders =
{
    accept: 'application/json',
    'content-type': 'application/json',
};

const lireReponse = async (reponse) => {
    const contenuType = (reponse.headers.get('content-type') || '').toLowerCase();
    const texte = await reponse.text();

    if (!texte) {
        return undefined;
    }

    if (contenuType.includes('application/json')) {
        return JSON.parse(texte);
    }

    return texte;
};

export default (input: RequestInfo | URL, init?: RequestInit): Promise<unknown> =>
    fetch(input, { credentials: 'omit', ...init })
    .then(reponse => new Promise<unknown>((resolve, reject) => {

        if (erreursParticulieres.has(reponse.status)) {
            reject(new Error(String(reponse.status)));
            return;
        }

        if (!reponse.ok) {
            lireReponse(reponse).then(erreur => {
                reject(erreur || new Error(String(reponse.status)));
            }).catch(() => {
                reject(new Error(String(reponse.status)));
            });
            return;
        }

        if (reponse.status === NO_CONTENT) { 
            resolve(undefined);
            return;
        }

        lireReponse(reponse).then(contenu => {
            resolve(contenu);
        }).catch(error => {
            reject(error);
        });
    }));